<template>
    <div>
    <div class="d-body">
        <div id="main-b" class="main-bg">
            <div class="det-image" :style="`background-image:url(${require('../../img/work/' + db[path].image)})`"></div>
            <div class="det-body">
                <div class="poster-img">
                    <img style="width:100%" :src="require('../../img/posters/' + db[path].poster)" alt="">
                </div>
                <div class="dets">
                    <span class="d-title">{{db[path].title}}</span>
                    <span class="d-year">{{db[path].year}}</span>
                    <div class="links">
                        <a target="_blank" :href="db[path].imdb" class="link-item">IMDB</a>
                    </div>
                    <div class="director-box">
                        <span style="font-size:12pt;">Director:</span> {{db[path].director}}<br>
                        <span style="font-size:12pt;">Writer:</span> {{db[path].writer}}
                    </div>
                    <div style="color:#fff">CAST:</div>
                    <div class="cast-box">
                        <div v-for="(item, i) in db[path].cast" :key="i" class="cast-item">
                            <div class="cast-img"><img :src="require('../../img/cast/' + item.image)" style="width:100%;" alt=""></div>
                            <div class="cast-name">{{item.name}}<span>{{item.role}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import db from './db.json';
export default {
    name:'details',
    
    data(){
        return {
            db,
            isLoading:false,

        }
    },
    mounted(){
        console.log(db);
        let el = window.document.getElementById('main-b');
        el.style.backgroundImage = `src(${this.image})`
    },
    computed:{
        path(){
            return this.$route.params.id;
        },
    }
}
</script>
<style>
.d-body{
    padding:0px 10%;
}
.d-title{
    display:block;
    color:#ffffff; 
    font-size:50pt; 
    font-weight:500; 
    text-transform:uppercase;
    line-height:50pt
}
.d-year{
    display:block;
    color:#ffffff; 
    font-size:25pt; 
    font-weight:300; 
    text-transform:uppercase
}
.links{
    margin:10px 0px;
    display:flex;
    align-items: flex-start;
}
.link-item{
    border:solid 1px #fff;
    display:flex;
    align-items: center;
    height:40px;
    padding:0px 15px;
    color:#fff;
    background:#000;
    font-size:12pt;
    cursor: pointer;
    transition: all .3s ease;
}
.link-item:hover{
    color:#fff;
    background:#1a1a1a;
}
.director-box{
    color:#fff;
    text-transform: uppercase;
}
.cast-box{
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    width:100%;
    height:200px;
    flex-grow: unset;
}
.cast-name{
    margin-left:10px;
    font-size:16pt;
    color:#fff;
    font-weight: 300;
    text-transform: uppercase;
}
.cast-name span{
    display: block;
    font-weight: 200;
    font-size: 12pt;
    
}
.cast-item{
    display: flex;
    align-items: center;
    background:#ffffff30;
    padding:15px;
    flex-basis:33.2%;
    margin:5px;
    width:200px;
}
.cast-img{
    width:50px;
    
}
.dets{
    padding:25px;
    padding-left:360px;
}
.poster-img{
    position:absolute;
    left:50px;
    top:-170px;
    max-width:300px;
    box-shadow: 1px 12px 10px rgba(0,0,0,0.3);
}
.det-body{
    margin-top:500px;
    background:#00000050;
    backdrop-filter: blur(10px);
    
    top:0;
    width:100%;
    padding:15px;
    position: relative;
    z-index: 100;
    padding-bottom:200px;
}
.det-image{
    background-size: cover;
    background-position: center -170px;
    box-shadow: inset 0px -100px 40px rgba(0,0,0,1);
    width:100%;
    position:absolute;
    height:100%;
    max-height:800px;
    top:0;
    z-index: 0;
}
.main-bg{
    min-height:100vh;
    position: relative;
    z-index: 10;
    padding-top:80px;
    top:0;
    height:100%;
    background:#000;
    color:#000;
    width:100%;
    background-size:cover;
    background-position: center center;
}
@media(max-width:720px){
    .poster-img{
        left:0;
        max-width: calc(100% - 100px);
        left:50px;
        width:100%;
        
    }
    .d-body{
        padding:0;
    }
    .dets{
        padding:0;
        padding-bottom:200px;
        width:100%;
        margin-top:280px;
    }
    .main-bg{
        min-height: 50vh;
    }
    .d-title{
        font-size:35pt;
    }
    .det-image{
        max-height:800px;
    }
    .cast-item{
        padding:15px;
        width:100%;
        flex-basis: 100%;
    }
}
</style>